var map = {
	"./Bolivia.jpg": "6fa6",
	"./England.jpg": "9755",
	"./Norway.jpg": "2abf",
	"./fcc_primary_small.png": "bf38",
	"./fcc_secondary_small.png": "ad2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb7d";